export default "__VITE_ASSET__w8$Blrs2D6UVeYypKwpAMQ__"